import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function HowWeHelp() {
  return <section className="py-20 md:py-28 bg-warm-white px-6" data-id="element-141">
      <div className="max-w-[1100px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-142">
        {/* Left Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-144">
            How We Help You
          </h2>
          <p className="text-charcoal text-lg leading-relaxed mb-8" data-id="element-145">
            Whether you're looking to buy Indexed Universal Life insurance for
            the first time or optimize an existing policy, we guide you through
            every step. From getting Indexed Universal Life insurance quotes to
            policy delivery and beyond, we make the process simple and
            transparent.
          </p>

          <ul className="space-y-4" data-id="element-146">
            {['Clarify your goals for protection, cash value, and potential tax-free retirement income', 'Compare IUL insurance options and carriers side-by-side', 'Design an IUL policy structure aligned with your budget and time horizon', 'Provide ongoing reviews to help keep your IUL insurance policy on track'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-147">
                <div className="mt-1 w-5 h-5 rounded-full bg-copper/10 flex items-center justify-center shrink-0" data-id="element-148">
                  <Check className="text-copper w-3.5 h-3.5" strokeWidth={3} data-id="element-149" />
                </div>
                <span className="text-charcoal font-medium" data-id="element-150">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Right Column - Process Card */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-forest rounded-2xl p-8 md:p-12 shadow-xl text-white relative overflow-hidden" data-id="element-151">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16" data-id="element-152"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full -ml-12 -mb-12" data-id="element-153"></div>

          <h3 className="text-2xl font-bold text-white mb-6 relative z-10" data-id="element-154">
            A clear, step-by-step process
          </h3>
          <p className="text-white/90 text-lg leading-relaxed relative z-10" data-id="element-155">
            We remove the complexity from Indexed Universal Life insurance by
            breaking everything into simple, transparent steps, so you always
            know what comes next and why it matters.
          </p>
        </motion.div>
      </div>
    </section>;
}